export default {
	// always apply validation
	ALWAYS: 'ALWAYS',
	// only apply if the data element has lost focus / blurred
	BLURRED: 'BLURRED',
	// never apply validation
	NEVER: 'NEVER',
};
